var sendTracking = function sendTracking(key, value) {
  var _window;
  // Track user progress
  (_window = window) === null || _window === void 0 || (_window = _window.analytics) === null || _window === void 0 || _window.track(key, value);
};
export { sendTracking as default };